// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3DlVR","selected":"Chip_selected__1_RjV"};